import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const email = (params.get("e") || "").trim();
  const token = (params.get("t") || "").trim();
  const [state, setState] = useState("loading"); // loading | ok | invalid | err
  const [serverEmail, setServerEmail] = useState("");

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!email || !token) {
        setState("invalid");
        return;
      }
      try {
        const r = await fetch(
          `${API}/credit-union/unsubscribe?e=${encodeURIComponent(email)}&t=${encodeURIComponent(token)}`
        );
        if (cancelled) return;
        if (r.status === 400) {
          setState("invalid");
          return;
        }
        if (!r.ok) {
          setState("err");
          return;
        }
        const data = await r.json();
        setServerEmail(data.email || email);
        setState("ok");
      } catch (e) {
        if (!cancelled) setState("err");
      }
    }
    run();
    return () => { cancelled = true; };
  }, [email, token]);

  return (
    <div
      data-testid="unsubscribe-page"
      className="min-h-[70vh] bg-[#0A0A0A] text-[#FDFBF7] flex items-center justify-center px-6 py-20"
    >
      <div className="max-w-xl w-full border border-[#D4AF37]/25 bg-[#111] p-10">
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] mb-3">
          Email Preferences
        </div>
        {state === "loading" && (
          <>
            <h1 className="font-serif text-3xl mb-3">Processing your request…</h1>
            <p className="text-sm text-[#FDFBF7]/70">
              One moment while we update your email preferences.
            </p>
          </>
        )}
        {state === "ok" && (
          <>
            <h1 className="font-serif text-3xl mb-3" data-testid="unsub-success-title">
              You've been unsubscribed.
            </h1>
            <p className="text-sm text-[#FDFBF7]/70 leading-relaxed">
              <span className="text-[#D4AF37]" data-testid="unsub-email">{serverEmail}</span>{" "}
              will no longer receive our nurture emails about the proposed Trillion Dollar
              Spending Power Federal Credit Union charter effort.
            </p>
            <p className="text-xs text-[#FDFBF7]/50 mt-6 leading-relaxed">
              You can still return any time at{" "}
              <Link to="/the-case" className="text-[#D4AF37] underline">
                /the-case
              </Link>{" "}
              to re-reserve your spot — this change only turns off our follow-up emails.
            </p>
          </>
        )}
        {state === "invalid" && (
          <>
            <h1 className="font-serif text-3xl mb-3" data-testid="unsub-invalid-title">
              Invalid unsubscribe link.
            </h1>
            <p className="text-sm text-[#FDFBF7]/70">
              The link you clicked is missing or expired. If you want to stop receiving our
              emails, reply directly to the last one you got and we'll handle it manually.
            </p>
          </>
        )}
        {state === "err" && (
          <>
            <h1 className="font-serif text-3xl mb-3">Something went wrong.</h1>
            <p className="text-sm text-[#FDFBF7]/70">
              We couldn't reach the server. Please try again in a moment.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
